import axios from "axios";

const marketingAPI = axios.create({
  baseURL: "https://missionmap-lc.onrender.com/api/marketing-location", // ← REMOVE THE APOSTROPHE
});

marketingAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default marketingAPI;